import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  userDetails!: any;
  isArabic!: boolean;
  modalRef!: BsModalRef;
  constructor(private storageService: StorageService, private commonService: CommonService,
    private assessmentService: AssessmentService, private modalService: BsModalService) { }

  ngOnInit(): void {
    let userData = this.storageService.getSessionStorageData('userDetails');
    //console.log('sessionData in assessment: ',userData);
    this.isArabic = this.storageService.getSessionStorageData('isArabic');

    const rqstBody = { contactId: userData?.contactId };
    this.assessmentService.getUserData(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get user data in user profile: ', decryptedData);
      this.userDetails = JSON.parse(JSON.stringify(decryptedData));
      //console.log('user details in user profile: ',this.userDetails);
      if (!this.userDetails?.isActivate) {
        this.showDeactivationPopup();
      }
    });
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

}
